import { AfterViewInit, Component, Inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions, MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommunicationsProvider } from '../../providers/communications-provider';
import { MatIcon } from "@angular/material/icon";
import { MatError, MatFormField, MatHint, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { NgIf } from "@angular/common";
import { MatButton } from "@angular/material/button";

@Component({
  selector: 'rename-dialog',
  providers: [],
  styleUrls: ['./message-dialog.scss'],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatIcon,
    MatDialogContent,
    MatLabel,
    MatFormField,
    TranslateModule,
    ReactiveFormsModule,
    MatInput,
    CdkTextareaAutosize,
    NgIf,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatError,
    MatHint
  ],
  templateUrl: './message-dialog.component.html'
})
export class CommunicationMessageDialogComponent implements AfterViewInit {

    public readonly MESSAGE_MAX_LENGTH: number = 3000;
    public form: FormControl = new FormControl('', [
        Validators.required
    ]);

    constructor(
        public dialog: MatDialogRef<CommunicationMessageDialogComponent>,
        private _translater: TranslateService,
        private communicationProvider: CommunicationsProvider,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.form.setValue(data?.message || '');
    }

    public ngAfterViewInit() {}

    public onConfirmClicked(): void {
        if (this.form.valid) {
            this.dialog.close(this.form.value);
        } else {
            this.form.markAllAsTouched();
        }
    }
}
